import {OfflinePageProps} from 'Event/JoinArea/OfflinePage'
import React from 'react'
import Page, {DescriptionText} from 'Event/template/SimpleBlog/Login/Page'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'
import {useGuestVariables} from 'Event'
import Configurable from 'organization/Event/Configurable'
import OfflineContentConfig from 'Event/template/SimpleBlog/EventOfflinePage/OfflineContentConfig'

export default function OfflinePage(props: OfflinePageProps) {
  const v = useGuestVariables()

  return (
    <Page isPreview={props.isPreview}>
      <Configurable
        aria-label="event offline content config"
        dataTestId="event offline config"
      >
        <OfflineContentConfig />
        <>
          <OfflineTitle>{v(props.title)}</OfflineTitle>
          <Text>
            <div dangerouslySetInnerHTML={{__html: v(props.description)}} />
          </Text>
        </>
      </Configurable>
    </Page>
  )
}

function OfflineTitle(props: {children: string}) {
  const {login, linkColor, linkUnderline, offlinePage} = useSimpleBlogTemplate()

  if (!props.children) {
    return null
  }

  return (
    <DescriptionText
      textColor={offlinePage.titleTextColor ?? login.description.color}
      fontSize={offlinePage.titleFontSize ?? 24}
      disableMargin
      linkColor={linkColor}
      linkUnderline={linkUnderline}
    >
      {props.children}
    </DescriptionText>
  )
}

function Text(props: {
  children: string | React.ReactElement
  'aria-label'?: string
}) {
  const template = useSimpleBlogTemplate()
  const {login, linkColor, linkUnderline} = template
  const color = login.description.color
  const fontSize = template.login.description.fontSize
  if (!props.children) {
    return null
  }

  return (
    <DescriptionText
      textColor={color}
      fontSize={fontSize}
      aria-label={props['aria-label']}
      linkColor={linkColor}
      linkUnderline={linkUnderline}
    >
      {props.children}
    </DescriptionText>
  )
}
